import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

/**
 * Removes a slide's .swiper-lazy-preloader once its image or 3D model has loaded. Swiper only
 * does this for load events it sees itself, and WP Rocket can delay main.js until the images
 * have already loaded, which left the spinner on top of them.
 */
function removeLoadedPreloaders (el) {
  el.querySelectorAll('.swiper-slide').forEach(slide => {
    const preloader = slide.querySelector('.swiper-lazy-preloader')
    const media = slide.querySelector('img, model-viewer')

    if (!preloader || !media) {
      return
    }

    const loaded = media.tagName === 'IMG' ? media.complete : media.loaded

    if (loaded) {
      preloader.remove()
      return
    }

    media.addEventListener('load', () => preloader.remove(), { once: true })
    media.addEventListener('error', () => preloader.remove(), { once: true })
  })
}

export default class ThemeSwiper extends Swiper {
  constructor (el, params = {}) {
    super(el, params)

    removeLoadedPreloaders(this.el)
    // Sliders whose slides are replaced over AJAX call update() afterwards
    this.on('update', () => removeLoadedPreloaders(this.el))
  }
}
